import { Component } from "@angular/core";
import { ToastNotificationService } from "./toast-notification.service";

@Component({
  selector: "app-toast-notification",
  templateUrl: "./toast-notification.component.html",
  styleUrls: ["./toast-notification.component.css"],
})
export class ToastNotificationComponent {
  constructor(public toastService: ToastNotificationService) {}

  rotulo(tipo: string): string {
    switch (tipo) {
      case "success":
        return "Sucesso";
      case "warning":
        return "Atenção";
      case "info":
        return "Informação";
      default:
        return "Erro";
    }
  }
}
